import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash,faSpinner } from '@fortawesome/free-solid-svg-icons';
import './sidebar.css';
import { useAtomValue, useSetAtom } from 'jotai';
import { sheetData, airesponse, selectdata, insertDirectionAtom, rowIndexAtom, colIndexAtom, aiResponseColumnsAtom } from '../../Atoms';
import JSON5 from 'json5'; // Import json5
import { BE_URL } from '../../constants';
import Swal from 'sweetalert2'
const Sidebar = () => {
  const data = useAtomValue(sheetData);
  const setairesponse = useSetAtom(airesponse);
  const [profiles, setProfiles] = useState([{ name: 'Default Profile', prompt: 'First understand and respond ' }]);
  const [selectedProfileIndex, setSelectedProfileIndex] = useState(0);
  const [model, setModel] = useState('Grok Ai');
  const [loading, setLoading] = useState(false);
  const [isAddingProfile, setIsAddingProfile] = useState(false);
  const [newProfileName, setNewProfileName] = useState('');
  const [newProfilePrompt, setNewProfilePrompt] = useState('');
  const [missionInput, setMissionInput] = useState('');
  const extractedValues = useAtomValue(selectdata);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [aiResponses, setAiResponses] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [insertDirection, setInsertDirection] = useState('row');
  const [rowIndex, setRowIndex] = useState('');
  const [colIndex, setColIndex] = useState('');
  const setcol = useSetAtom(colIndexAtom);
  const setrow = useSetAtom(rowIndexAtom);
  const setdirection = useSetAtom(insertDirectionAtom);
  const aiResponseColumns = useSetAtom(aiResponseColumnsAtom);
  const [shouldFlatten, setShouldFlatten] = useState(false);

  useEffect(() => {
    if (data) {
      setProfiles(prevProfiles => {
        return prevProfiles.map((profile, index) => ({
          ...profile,
          prompt: data[index]?.prompt || profile.prompt,
        }));
      });
    } else {
      console.warn('No data available to set');
    }
  }, [data]);

  const showNotification = (message, duration = 3000) => {
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.innerText = message;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.classList.add('show');
    }, 10);

    setTimeout(() => {
      notification.classList.remove('show');
      notification.classList.add('hide');

      setTimeout(() => {
        document.body.removeChild(notification);
      }, 500);
    }, duration);
  };

  const handleProfileChange = (event) => {
    const index = parseInt(event.target.value, 10);
    setSelectedProfileIndex(index);
  };

  const handleNewProfileNameChange = (event) => {
    setNewProfileName(event.target.value);
  };

  const handleNewProfilePromptChange = (event) => {
    setNewProfilePrompt(event.target.value);
  };

  const addProfile = () => {
    setIsAddingProfile(true);
  };

  const saveNewProfile = () => {
    if (newProfileName.trim() === '') {
      showNotification('Profile name cannot be empty');
      return;
    }

    setProfiles(prevProfiles => [
      ...prevProfiles,
      { name: newProfileName, prompt: newProfilePrompt },
    ]);

    setNewProfileName('');
    setNewProfilePrompt('');
    setIsAddingProfile(false);
    setSelectedProfileIndex(profiles.length);
  };

  const handleSaveClick = async () => {
    if (!profiles[selectedProfileIndex]) {
      showNotification('Please select a profile.');
      return;
    }

    if (!missionInput.trim()) {
      showNotification('Please enter the mission details.');
      return;
    }

    const selectedProfilePrompt = profiles[selectedProfileIndex]?.prompt || '';
    if (!selectedProfilePrompt.trim()) {
      showNotification('The selected profile does not have a prompt.');
      return;
    }

    setLoading(true);
    ;
    try {
      const response = await startSendingData();
      if (response && response.aiResponses) {
        
        const aiResponses = response.aiResponses;

        // Clean and parse responses using JSON5
        const processedResponses = Object.keys(aiResponses).map(key => {
          try {
            // Clean up JSON string
            const cleanString = aiResponses[key][0].trim();
            // Parse JSON string using JSON5
            const parsedResponse = JSON5.parse(cleanString);
            return parsedResponse;
          } catch (error) {
            console.error(`Error parsing JSON string for key ${key}:, error `);
            return null;
          }
        }).filter(response => response !== null);

        setAiResponses(processedResponses);
        // Set headers based on the keys of the first response object
        if (processedResponses.length > 0) {
          setHeaders(Object.keys(processedResponses[0]));
        }
        setShowTable(true);
      }
    } catch (error) {
      console.error('Error during data send:', error);
      showNotification('Error while sending data.');
    } finally {
      setLoading(false);
    }
  };
  const keys = Object.keys(aiResponses);
  // console.log('Keys:', keys); 
  
  // Initialize an array to hold key-value pairs and a Set to track unique keys
  const keyValues = [];
  const uniqueKeys = new Set();
  
  // Loop through each key in the aiResponses
  keys.forEach(key => {
      // Access the associated object
      const itemsObject = aiResponses[key];
  
      // Check if itemsObject is indeed an object
      if (typeof itemsObject === 'object' && !Array.isArray(itemsObject)) {
          // Get the keys of the itemsObject
          const itemKeys = Object.keys(itemsObject);
  
          // Loop through each key to get its value
          itemKeys.forEach(itemKey => {
              // Check if the key is already in the Set
              if (!uniqueKeys.has(itemKey)) {
                  // If not, add it to the Set and the keyValues array
                  uniqueKeys.add(itemKey);
                  keyValues.push({ key: itemKey });
              }
          });
      } else {
          console.warn(`Expected an object for key "${key}", but got:`, itemsObject);
      }
  });
  
  // Log the extracted key-value pairs without duplicates
  // console.log('Key Values:', keyValues);
  const startSendingData = async () => {
    try {
      const selectedProfilePrompt = profiles[selectedProfileIndex]?.prompt || '';
      // console.log('myextractedvalues::',extractedValues);
      
      // If no data available, send an empty array instead of slicing an empty array.
      const dataToSend = (extractedValues && extractedValues.length > 0 ? extractedValues : data).slice(1) || ['PLEASE undersTAND MY REQUESTAND RESPONSE BE '];
    //  console.log('sending values: ', dataToSend);
     
      const url = `${BE_URL}api/files//savesss2`
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          savedata: extractedValues, // Send the data (empty or non-empty)
          missionInput: missionInput, // Use mission input separately
          profilePrompt: selectedProfilePrompt, // Send the selected profile's prompt
          model: model
        }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error ${response.status}: ${errorData.message}`);
      }
  
      const responseData = await response.json(); // Get the response data
      // console.log('responseData++0--',responseData);
      
      const responseMessage = responseData.message || "No message received"; // Extract the response message
      // console.log("Server Response Message:", responseMessage); 
      showNotification(responseMessage)// Log the response message
      Swal.fire({
        // position: "top-end",
        icon:"info",
        title: responseMessage,
        showConfirmButton: false,
        timer: 2500
      });;
    
      return responseData;  // Return the response data
    } catch (error) {
      console.error('Error sending data:', error);
    }
  };

  const handleConfirm = () => {
    if (insertDirection && rowIndex && colIndex) {
      setdirection(insertDirection);
      setrow(rowIndex);
      setcol(colIndex);
      // console.log("airesponse",JSON.stringify(aiResponses))
      // Map the AI responses for the selected column
      const ai = shouldFlatten 
      ? aiResponses.map(item => item[colIndex] !== undefined ? item[colIndex] : null).flat()
      : aiResponses.map(item => item[colIndex] !== undefined ? item[colIndex] : null);

      // console.log("ai after",ai)
      // Add the first row with the label 'AI Response'
      const aiWithHeader = [[colIndex], ...ai];
  
      // Set the AI response columns with the header included
      aiResponseColumns(aiWithHeader);
  
      setSidebarVisible(true);
    } else {
      showNotification("Please enter all fields");
    }
  };

  const deleteProfile = (index) => {
    setProfiles(prevProfiles => prevProfiles.filter((_, i) => i !== index));
    setSelectedProfileIndex(0); // Reset to the default profile
  };

  const handleCancel = () => {
    setSidebarVisible(true); // Show sidebar
    setShowTable(false); // Hide the AI response table
  };
// console.log(aiResponses)
  return (
    <div>
      {sidebarVisible && !showTable && (
        <div className="sidebar">
          <div className="header">
            <span className="title">AI Web Researcher Panel</span>
          </div>
          <p className="description">I can search the web, visit websites, and gather information for you!</p>
          <div className="model-select">
            <label>Selected Model</label>
            <div className="select-wrapper">
              <select value={model} onChange={(e) => setModel(e.target.value)}>
                <option value="Grok Ai">Grok Ai</option>
                <option value="ChatGPT">Chat gpt</option>
              </select>
            </div>
          </div>
          <div className="profile-select">
            <label className='pro'>Selected Profile:</label>
            <div className="profile-select-wrapper">
              <select className="select" value={selectedProfileIndex} onChange={handleProfileChange}>
                  {profiles.map((profile, index) => (
                    <option key={index} value={index}>
                      {profile.name}
                    </option>
                  ))}
              </select>
              <div onClick={addProfile} className="add-profile-button">
                <FontAwesomeIcon icon={faPlus} />
              </div>
              <div className="delete-profile-button" onClick={() => deleteProfile(selectedProfileIndex)}>
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
          {isAddingProfile && (
            <div className="new-profile">
              <input
                type="text"
                placeholder="Enter new profile name"
                value={newProfileName}
                onChange={handleNewProfileNameChange}
              />
              <textarea
                placeholder="Enter new profile prompt"
                value={newProfilePrompt}
                onChange={handleNewProfilePromptChange}
              ></textarea>
              <button onClick={saveNewProfile}>Save New Profile</button>
            </div>
          )}
            <label className='mission'>
              Mission Details:
              <textarea
              className='mission-input'
                placeholder="Must follow instruction for Good output:
                First define all column name you want exg.(Column Named:'email-content'
                Then mission format start like eg(give me [number of column] column in this [name of column] i want..."
                value={missionInput}
                onChange={(e) => setMissionInput(e.target.value)}
              ></textarea>
            </label>
            <button className="save-button" onClick={handleSaveClick} disabled={loading}>
  {loading ? (
    <>
      <p className="loading-message">AI Making Response, please wait...</p>
      <FontAwesomeIcon icon={faSpinner} spin style={{ color: 'white' }} />
    </>
  ) : (
    'Save'
  )}
</button>
{/* {loading && <p className="loading-message">AI Making Response, please wait...</p>} */}
          <p>{extractedValues.keys}</p>
        </div>
      )}

      {showTable && (
        <div className="tablec">
          <center><h2>AI Responses Panel</h2></center>
          <br></br>
          <text className='mission'>"Try different prompts to achieve the desired results. If any rows are empty or don’t give expected outcomes, select those rows or columns and try again to get the results in the correct cells." </text>
         
          {/* <div className="results">
  <table>
    <thead>
      <tr>
        {headers.map((header, index) => (
          <th key={index}>{header}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {aiResponses.map((response, rowIndex) => (
        <tr key={rowIndex}>
          {headers.map((header, colIndex) => (
            <td key={colIndex}>
              {typeof response[header] === 'object' && !Array.isArray(response[header]) 
                ? JSON.stringify(response[header]) // Convert object to string
                : Array.isArray(response[header]) 
                ? response[header].join(', ') // Handle arrays
                : response[header]} 
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div> */}
<div className="results">
            <table>
              <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {aiResponses.map((response, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((header, colIndex) => (
                      <td key={colIndex}>
                        {Array.isArray(response[header]) ? response[header].join(', ') : response[header]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="row-col-decide">
  <label className='mission'>
    Insert AI Responses Into Spreadsheet Row/Col:<br />
    <select value={insertDirection} onChange={(e) => setInsertDirection(e.target.value)}>
      <option value="row">Row</option>
      <option value="column">Column</option>
    </select>
  </label>
</div>

<div className="inputs">
  <label className='mission'>
    Which Spreadsheet Index:
    <input
      className='int'
      type="number"
      value={rowIndex}
      onChange={(e) => setRowIndex(e.target.value)}
      placeholder={insertDirection === "row" ? "Enter row index" : "Enter column index"}
    />
  </label><br />

  <label className='mission'>
        Select AI Response Column:
        <select value={colIndex} onChange={(e) => setColIndex(e.target.value)}>
            <option value="">Select a column</option>
            {keyValues.map(({ key }) => (
                <option key={key} value={key}>
                    {key} {/* Display the column key */}
                </option>
            ))}
        </select>
    </label>
    <br></br>
    <label className="mission">
    Organize by cell:
    <input
      type="checkbox"
      checked={shouldFlatten}
      onChange={(e) => setShouldFlatten(e.target.checked)}
    />
  </label>
          </div>

          <button onClick={handleConfirm} className="save-button">Add to Spreadsheet</button>
          <button onClick={handleCancel} className="save-button">Back to Panel</button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;